import Layout from '@/components/layout/Layout';
import { FC, useState } from 'react';
import BookCardItem from '@/components/ui/book-card-item/BookCardItem';
import Pagination from '@/components/ui/pagination/Pagination';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import CardsControls from '@/components/ui/cards-controls/CardsControls';
import { BOOKS_FOR_PAGE } from '@/helpers/variables';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { getAuthorFullName } from '@/helpers/helpers';
import { IMenuData } from '@/interfaces/menu.interface';
import { IReaderDetail } from '@/interfaces/readerDetail.interface';

interface IAuthorDetailProps extends IMenuData {
  reader: IReaderDetail;
}

const ReaderDetail: FC<IAuthorDetailProps> = ({ reader, menuGenres, menuNew }) => {
  console.log(reader);

  const pagesCount = Math.ceil(reader.person_books_count / BOOKS_FOR_PAGE);
  const readerFullName = getAuthorFullName(reader.first_name, reader.middle_name, reader.last_name);
  const [isCardsColumn, setIsCardsColumn] = useState(false);

  const SEO_TITLE = `${readerFullName} - список всех книг чтеца скачать или читать онлайн бесплатно`;
  const SEO_DESCRIPTION = `Фензин - электронная библиотека, где вы можете послушать все книги чтеца «${readerFullName}» или скачать в fb2, epub, txt, pdf`;
  const SEO_CANONICAL = `/library/author/${reader.id}`;

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()} menuGenres={menuGenres} menuNew={menuNew}>
      <Breadcrumbs firstPageName={readerFullName} />

      <SectionTitle name={readerFullName} extraClassName="mainTitle_filter" />

      <div data-btn-cards={isCardsColumn ? 'tiles' : 'rows'}>
        <CardsControls setIsCardsColumn={setIsCardsColumn} extraClassName="" />
        <h2 className="h2">Книги чтеца: {readerFullName}</h2>
      </div>
      <div data-cards="list">
        <div className="bookCardsList">
          {reader.books.length > 0 ? (
            reader.books.map((book) => (
              <BookCardItem
                type={book.type}
                freeVersion={!!book.allow_full_free && book.allow_full_free > 0}
                key={book.id}
                id={book.id}
                author={{ first_name: book.author_first_name, middle_name: book.author_middle_name, last_name: book.author_last_name, id: book.author_id }}
                book={{ title: book.title, description: book.description, external_id: book.external_id }}
                rating={book.rating}
              />
            ))
          ) : (
            <div>Книги не найдены</div>
          )}
        </div>
      </div>
      <Pagination pagesCount={pagesCount ?? 0} postName={`library/reader/${reader.alias}/page-library=`} />
    </Layout>
  );
};

export default ReaderDetail;
